import React, { useState, useEffect } from "react";
//css & images
import "./Home.css";
import greenTick from "../Images/tick-icon.png";
//functions
import ValidateForm from "../Functions/ValidateForm";
import formResponse from "../Functions/formResponse";
import apiComponents from "../Functions/apiComponents";
import getCookieParam from "../Functions/getCookieParam";
//components
import { showToaster } from "../Components/Toaster";

//enter email form
const EmailForm = (props) => {
  function submitForm(e) {
    e.preventDefault();
    if (ValidateForm('emailForm')) {
      document.getElementById('emailSubmitButton').disabled = true;
      localStorage.setItem('email', e.currentTarget.previousSibling.childNodes[0].value);
      fetch(apiComponents.otp, {
        headers: {
          'accept': 'application/json',
          'content-type': 'application/json',
          'partnerName': getCookieParam('partnerName'),
        },
        method: 'POST',
        body: JSON.stringify({
          email: localStorage.getItem('email')
        })
      }).then(async res => {
        document.getElementById('emailSubmitButton').disabled = false;
        if (await formResponse(res)) {
          showToaster('', 'OTP sent!', 'Please check your inbox for OTP');
          props.showOtpFormFunc(true);
        }
      });
    }
  }
  return (
    <>
      <h2 className="secondary-heading" style={{ marginBottom: "32px" }}>Please enter your email to proceed</h2>
      <form id="emailForm">
        <div>
          <input type="email" placeholder="Enter email address" id="emailInput" required></input>
          <div className="errorText">Please enter a valid email id</div>
        </div>
        <button onClick={event => submitForm(event)} className="red-button" id="emailSubmitButton">Continue</button>
      </form>
    </>
  );
}

//enter otp form
const OtpForm = (props) => {
  //otp form submit button click
  function submitForm(e) {
    e.preventDefault();
    if (ValidateForm('otpForm')) {
      document.getElementById('otpSubmitButton').disabled = true;
      fetch(apiComponents.login, {
        headers: {
          'accept': 'application/json',
          'content-type': 'application/json',
          'partnerName': getCookieParam('partnerName'),
        },
        method: 'POST',
        body: JSON.stringify({
          email: localStorage.getItem('email'),
          otp: Number(document.getElementById('otpInput').value),
        })
      }).then(async res => {
        document.getElementById('otpSubmitButton').disabled = false;
        if (await formResponse(res)) {
          res.json().then(data => {
            document.cookie = `token=${data.token}; path=/; max-age=3600`;
            fetch(apiComponents.customer, {
              headers: {
                'accept': 'application/json',
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + getCookieParam('token')
              },
            }).then(async res => {
              if (await formResponse(res)) {
                showToaster('', 'Login successful!', 'User data loaded successfully');
                res.json().then(data => {
                  props.validOtpFunc(data.token);
                  document.cookie = `step=${data.u_step}; path=/`;
                  document.cookie = `subStep=${data.u_substep}; path=/`;
                  document.cookie = `statusPercent=${data.u_status}; path=/`;
                });
              }
            });
          });
        }
      });
    }
  }
  //submit otp form on enter button click
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("otpSubmitButton").click();
    }
  }
  //resend otp
  const resendOtp = (e) => {
    let btn = e.currentTarget;
    fetch(apiComponents.otp, {
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        'partnerName': getCookieParam('partnerName'),
      },
      method: 'POST',
      body: JSON.stringify({
        email: localStorage.getItem('email'),
      })
    }).then(async res => {
      if (await formResponse(res)) {
        btn.innerHTML = 'OTP resent! Please check your inbox';
        btn.style.color = "#767477";
        btn.style.cursor = "no-drop";
        btn.disabled = true;
        setTimeout(() => {
          btn.innerHTML = 'Resend OTP';
          btn.style.color = "#403F42";
          btn.style.cursor = "auto";
          btn.disabled = false;
        }, 5000);
      }
    });
  }
  //back to email form
  const backToEmailForm = (e) => {
    document.getElementById('otpInput').value = '000000';
    props.setshowOtpForm(false);
  }
  return (
    <>
      <h2 className="secondary-heading" style={{ marginBottom: "32px" }}>Please enter the OTP sent</h2>
      <form id="otpForm">
        <div>
          <input type="number" onKeyPress={event => handleKeyPress(event)} placeholder="Enter 6 digit OTP" id="otpInput" maxLength="6" required></input>
          <div className="errorText">Invalid OTP</div>
        </div>
        <div style={{ textDecoration: "underline", cursor: "pointer" }} onClick={event => resendOtp(event)}>Resend OTP</div>
        <div className="buttons-container">
          <button onClick={event => backToEmailForm(event)} className="grey-button">Enter email again</button>
          <button onClick={event => submitForm(event)} className="red-button" id="otpSubmitButton">Verify</button>
        </div>
      </form>
    </>
  );
}

const LoginComponent = (props) => {
  const [showOtpForm, setshowOtpForm] = useState(false);
  return (
    <>
      {showOtpForm === false ?
        <EmailForm showOtpFormFunc={setshowOtpForm} /> :
        <OtpForm validOtpFunc={props.showWelcomeComponent} showOtpFormFunc={setshowOtpForm} />}
    </>
  );
};

const WelcomeComponent = () => {
  let step = getCookieParam('step');
  let progressPercent = getCookieParam('statusPercent');

  useEffect(() => {
    //get 
    fetch(apiComponents.customer, {
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        'Authorization': `Bearer ${getCookieParam('token')}`
      },
    }).then(async res => {
      if (await formResponse(res)) {
        res.json().then(data => {
          document.cookie = `step=${data.u_step}; path=/`;
          document.cookie = `subStep=${data.u_substep}; path=/`;
          document.cookie = `statusPercent=${data.u_status}; path=/`;
        });
      }
    });
    let card = document.getElementsByClassName('card')[1];
    if (progressPercent === '100') {
      card.style.backgroundImage = `url(../Images/status-card-bg.svg)`;
      card.childNodes[1].style.display = "none";
      card.childNodes[2].style.display = "flex";
      document.getElementsByTagName("button")[0].value = "View API Key";
    }
    if (progressPercent !== '0') document.getElementsByTagName("button")[0].innerHTML = "Continue Onboarding";
    else document.getElementsByTagName("button")[0].innerHTML = "Start Onboarding";
  });

  const getProgressColor = (x) => {
    if (x > 0 && x <= 40) return "#25D366";
    else if (x > 40 && x <= 99) return "#EE5D0B";
    else if (x === 100) return "#A1D946";
  };

  const redirectToStep = () => {
    if (step === '1') window.location.pathname = `/${getCookieParam('partnerName')}/phone-number-verification`;
    else if (step === '2') window.location.pathname = `/${getCookieParam('partnerName')}/whatsapp-onboarding`;
    else if (step === '3') window.location.pathname = `/${getCookieParam('partnerName')}/whatsapp-onboarding`;
  };

  const logout = () => {
    document.cookie = 'token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'step=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'subStep=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'statusPercent=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    window.location.reload();
  };

  return (
    <>
      <div className="logged-in-wrapper">
        <div className="logged-in-container-1">
          <h2 className="secondary-heading" style={{ textAlign: "left", marginBottom: 0 }}>Before creating your account on WhatsApp, please ensure the following -{" "}</h2>
          <ul style={{ fontSize: "16px" }}>
            <li>Phone number to be used for WhatsApp Business APIs</li>
            <li>Ability to receive OTP on this number via call or SMS</li>
            <li>Number <a className="link" href="https://faq.whatsapp.com/605464643328528/?locale=en_US" target="_blank" rel="noopener noreferrer">should not be active</a> with any existing WhatsApp account</li>
            <li><a className="link" href="https://www.facebook.com/business/help/2058515294227817?id=180505742745347" target="_blank" rel="noopener noreferrer">Verified</a> Facebook (Meta) Business Manager account</li>
          </ul>
          <button className="red-button" onClick={event => redirectToStep(event)}>Start Onboarding</button>
        </div>
        <div className="logged-in-container-2">
          <div className="card">
            <h2>Onboarding Progress</h2>
            <div className="progress-bar-wrapper">
              <div className="progress-bar-outer"><div className="progress-bar-inner" style={{ width: progressPercent + '%', backgroundColor: getProgressColor(progressPercent) }}></div></div>
              <div style={{ color: getProgressColor(progressPercent) }} > {progressPercent}% complete </div>
            </div>
          </div>
          <div className="card" id="accountStatusCard">
            <h2>Account Status</h2>
            <ul>
              <li style={{ paddingBottom: "2px" }}>Display name verification pending</li>
              <li style={{ paddingBottom: "2px" }}>Facebook business manager verification pending</li>
            </ul>
            <div style={{ display: "none", color: "#A1D946", flexDirection: "row", gridRowGap: "10px" }}>
              <img alt="green tick mark icon" style={{ height: "16px", marginRight: "5px" }} src={greenTick} />
              Account is Live!
            </div>
          </div>
        </div>
      </div>
      <div className="link" style={{ position: "absolute", bottom: "64px" }} onClick={event => logout()}>Logout</div>
    </>
  );
};

const Home = () => {
  const [token, setToken] = useState(getCookieParam('token'));

    useEffect(() => {
    const parts = window.location.pathname.split("/");
    let firstPath = parts[1];
    if (!firstPath || firstPath === "check-status") {
    firstPath = "engati";
    }
    document.cookie = `partnerName=${firstPath}; path=/; SameSite=Lax`;
    }, []);
  return (
    <>
      {token === '' ?
        <LoginComponent showWelcomeComponent={setToken} /> :
        <WelcomeComponent />}
    </>
  );
};

export default Home;